import React from "react";
import { useFormik } from "formik";
import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";

import { TextField } from "@mui/material";

import * as Yup from "yup";
import { QuestionFooter } from "./QuestionFooter";

const CustomTextField = (props: any) => {
  return (
    <TextField
      className="survey-number-field"
      variant="standard" 
      InputProps={{ disableUnderline: true, type: props?.type ?? "text" }}
      {...props}
    />
  );
};

export const NumberInput = ({
  question,
  addAnswer,
  next,
  previous,
  options,
  initialValues,
}) => {
  const { values, handleChange, handleSubmit, isValid, errors } = useFormik({
    initialValues: {
      answer: initialValues?.value || "",
      required: !!question.required,
    },
    onSubmit: async (values) => {
      const answer = {
        questionId: question.id,
        answerText: values.answer,
      };


      const proceed = await addAnswer(question.id, answer ? [answer] : []);
      if(proceed){
        next();
      }
    },
    validateOnChange: true,

    validationSchema: Yup.object().shape({
      answer: Yup.string()
      .required("Es muss eine Zahl eingetragen werden.")
    }),
  });

  return (
    <div className="survey-choice">
      <div className="survey-number">
        <div className="survey-number-answer">Deine Antwort:</div>
        <div style={{ width: "100%" }}>
          <CustomTextField
            type="number"
            name="answer"
            value={values.answer}
            onChange={handleChange}
          />
        </div>
      </div>
      <QuestionFooter
        back={previous}
        onSave={handleSubmit}
        isValid={isValid}
        showErrorModal={errors.answer}
      />
    </div>
  );
};
